define('shared/pwa-polyfill',["jquery", "shared/browser-detect"], function($, BrowserDetect) {

	/**
	 * Initialize intercepts for the PWA
	 */
	function PWAPolyfill() {
		// For any browser thats not in a PWA this adds no extra overhead
		if(BrowserDetect.isMicrosoftPWA()) {
			// For the PWA we intercept all new tab clicks and open in current tab
			$(document).on("click", "a", function(e) {
				var targetURL = e.currentTarget.href;
				if(targetURL) {
					var host = targetURL.split('.com/')[0] + ".com";

					// We only want to intercept if the host matches the buncee host. If its external then it should be a new window/browser
					if( host === window.appData.client.web_url || targetURL.charAt(0) === "/") {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						window.location.href = targetURL;
					}
				}
			});	

			// Replace the window open function with our own
			window.open = function(url) {
				window.location.href = url;
			}
		}
	}

	return new PWAPolyfill();
});
